<div class="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
  <div class="max-w-md w-full space-y-8">
    <div class="text-center">
      <!-- Icon -->
      <div class="mx-auto flex items-center justify-center h-24 w-24 rounded-full bg-red-100 mb-6">
        <i class="pi pi-ban text-4xl text-red-600"></i>
      </div>
      
      <!-- Title -->
      <h1 class="text-3xl font-bold text-gray-900 mb-2" i18n>
        Access Denied
      </h1>
      
      <!-- Description -->
      <p class="text-lg text-gray-600 mb-8" i18n>
        You don't have permission to access this page. Please contact your administrator if you believe this is an error.
      </p>
    </div>

    <!-- Action Buttons -->
    <div class="flex flex-col sm:flex-row gap-4 justify-center">
      <p-button appGlobalLoadingDisable 
        i18n-label
        label="Go to Dashboard" 
        icon="pi pi-home" 
        (onClick)="goToDashboard()"
        styleClass="p-button-primary">
      </p-button>
      
      <p-button appGlobalLoadingDisable 
        i18n-label
        label="Go Back" 
        icon="pi pi-arrow-left" 
        (onClick)="goBack()"
        styleClass="p-button-secondary"
        [outlined]="true">
      </p-button>
    </div>

    <!-- Additional Info -->
    <div class="mt-8 text-center">
      <p class="text-sm text-gray-500" i18n>
        If you need access to this page, please contact your system administrator.
      </p>
    </div>
  </div>
</div>
